/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
/* eslint-disable max-len */
/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
import '../../assets/css/pages/main.css';
import '../../assets/css/pages/popup-main.css';
import Swiper, { Autoplay, EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';

import {
  setCookie, getCookie, serverDate,
} from '../utils/common';

import { LOAD_BASE_URL } from '../../config';

const modalBody = document.getElementById('modalBody');
const todayBtn = document.getElementById('today_close_btn');
const sectionTime = document.querySelector('.section_time');
const modal = document.getElementById('modalWrap');
const closeBtn = document.getElementById('closeBtn3');

let jsonData;
// let d;

function jsonRequest(url, callback) {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.onload = function () {
    if (xhr.status === 200) {
      callback(JSON.parse(xhr.responseText));
    } else {
      console.error(`Failed to load JSON file: ${xhr.statusText}`);
    }
  };
  xhr.send();
}

const slides = document.querySelectorAll('.sh_main_pick_wrap_mo img');
let current = 0;

const duration = 800;
const interval = 3000;

// 초기 z-index 설정
slides.forEach((s, i) => {
  s.style.position = 'absolute';
  s.style.top = 0;
  s.style.left = 0;
  s.style.width = '100%';
  s.style.height = '100%';
  s.style.objectFit = 'cover';
  s.style.zIndex = i === 0 ? 2 : 1;
});

function nextSlideFn() {
  const next = (current + 1) % slides.length;
  const currentSlide = slides[current];
  const nextSlide = slides[next];

  // 👉 3 → 1 일 때 fade 모드
  const isFade = (current === 2 && next === 0);

  if (isFade) {
    const originalSrc = currentSlide.src;
    currentSlide.src = 'https://image.chosun.com/halfmarathon/2026/motion_bg.png';

    nextSlide.style.transition = 'none';
    nextSlide.style.opacity = 0;
    nextSlide.style.transform = 'scale(0.8)';
    nextSlide.style.zIndex = 2;

    setTimeout(() => {
      nextSlide.style.transition = 'opacity 500ms cubic-bezier(0.25, 0.8, 0.5, 1), transform 300ms cubic-bezier(0.25, 0.8, 0.5, 1)';
      nextSlide.style.opacity = 1;
      nextSlide.style.transform = 'scale(1)';
    }, 200);

    nextSlide.addEventListener('transitionend', function handler() {
      currentSlide.src = originalSrc;
      currentSlide.style.zIndex = 0;
      nextSlide.style.zIndex = 1;
      current = next;
      nextSlide.removeEventListener('transitionend', handler);
    });

    return;
  }

  // 👉 일반 슬라이드 (clip-path)
  nextSlide.style.transition = 'none';
  nextSlide.style.clipPath = 'inset(0 0 0 100%)';
  nextSlide.style.zIndex = 2;

  setTimeout(() => {
    nextSlide.style.transition = `clip-path ${duration}ms ease`;
    nextSlide.style.clipPath = 'inset(0 0 0 0)';
  }, 20);

  nextSlide.addEventListener('transitionend', function handler() {
    currentSlide.style.zIndex = 0;
    nextSlide.style.zIndex = 1;
    current = next;

    nextSlide.removeEventListener('transitionend', handler);
  });
}

function startLoop() {
  nextSlideFn();
  setTimeout(startLoop, interval);
}

startLoop();

document.addEventListener('DOMContentLoaded', () => {
  const swiperDesktop = new Swiper('#sh_main_pick_sli_id_s', {
    loop: true,
    effect: 'fade',
    autoplay: { delay: 1500, disableOnInteraction: false },
    modules: [Autoplay, EffectFade],
  });

  // const swiperMobile = new Swiper('#sh_main_pick_sli_id_s_mo', {
  //   loop: true,
  //   effect: 'fade',
  //   fadeEffect: { crossFade: true },
  //   autoplay: {
  //     delay: 1800,
  //     disableOnInteraction: false,
  //   },
  // });

  // const ddayDayEl = document.querySelector('#d_day_days');
  // const ddayHourEl = document.querySelector('#d_day_hours');
  // const ddayMinuteEl = document.querySelector('#d_day_minutes');
  // const ddaySecondEl = document.querySelector('#d_day_seconds');
  // const d = new Date('2026-03-27T17:59:59'); // 대회일자

  // function getClock() {
  //   const dday = d - serverDate();
  //   const ddayDay = String(Math.floor((dday / (1000 * 60 * 60 * 24)))).padStart(2, '0');
  //   const ddayHour = String(Math.floor((dday / (1000 * 60 * 60)) % 24)).padStart(2, '0');
  //   const ddayMinute = String(Math.floor((dday / (1000 * 60)) % 60)).padStart(2, '0');
  //   const ddaySecond = String(Math.floor((dday / 1000) % 60)).padStart(2, '0');

  //   ddayDayEl.innerText = ddayDay;
  //   ddayHourEl.innerText = ddayHour;
  //   ddayMinuteEl.innerText = ddayMinute;
  //   ddaySecondEl.innerText = ddaySecond;

  //   serverDate().setSeconds(serverDate().getSeconds() + 1);
  // }

  // if (d > serverDate()) {
  //   // sectionTime.style.display = 'none';
  //   getClock();
  //   setInterval(getClock, 1000);
  // }

  jsonRequest(`${LOAD_BASE_URL}/json/half-popup.json`, (data) => {
    jsonData = data;

    const modalImg = document.getElementById('modal_img');

    if (getCookie('ch_notToday') === 'Y') {
      modal.style.display = 'none';
    } else if (jsonData && new Date(jsonData.endDate).getTime() > new Date().getTime()
      && new Date(jsonData.startDate).getTime() < new Date().getTime() && jsonData.pcImage && jsonData.pcImage !== '') {
      modal.style.display = 'block';
      modalBody.style.maxWidth = `${jsonData.width}px`;

      let jsonTarget;
      let jsonUrl;

      if (jsonData.url === '') {
        jsonTarget = '';
        // eslint-disable-next-line no-script-url
        jsonUrl = 'javascript:void(0);';
      } else {
        jsonTarget = '_blank';
        jsonUrl = jsonData.url;
      }

      modalImg.innerHTML = `
            <a target='${jsonTarget}' href='${jsonUrl}'>
              <img src='${LOAD_BASE_URL}/popup/${jsonData.pcImage}' class='desktop' style='max-height: 640px'>
              <img src='${LOAD_BASE_URL}/popup/${jsonData.mobileImage}' class='mobile'>
            </a>
          `;
    } else {
      modal.style.display = 'none';
    }
  });
});

todayBtn.addEventListener('click', () => {
  setCookie('ch_notToday', 'Y', 1);
  modal.style.display = 'none';
  document.body.style.position = 'initial';
});

closeBtn.addEventListener('click', () => {
  modal.style.display = 'none';
  document.body.style.position = 'initial';
});
